Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var utils = require('@alfalab/utils');
var utils_logWarning = require('./utils/logWarning.js');
var utils_trimTrailingZeros = require('./utils/trimTrailingZeros.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"amount__component_iua5w","transparentMinor":"amount__transparentMinor_iua5w","bold":"amount__bold_iua5w","normalMinor":"amount__normalMinor_iua5w","defaultStyles":"amount__defaultStyles_iua5w","defaultMinor":"amount__defaultMinor_iua5w","minorPartAndCurrency":"amount__minorPartAndCurrency_iua5w"};
require('./index.css');

/**
 * Компонент для отображения суммы, согласно следующему гайдлайну:
 * https://design.alfabank.ru/patterns/amount
 */
var Amount = function (_a) {
    var _b, _c;
    var value = _a.value, minority = _a.minority, currency = _a.currency, _d = _a.codeFormat, codeFormat = _d === void 0 ? 'symbolic' : _d, _e = _a.view, view = _e === void 0 ? 'default' : _e, bold = _a.bold, transparentMinor = _a.transparentMinor, rightAddons = _a.rightAddons, _f = _a.showPlus, showPlus = _f === void 0 ? false : _f, className = _a.className, _g = _a.trimZero, trimZero = _g === void 0 ? false : _g, dataTestId = _a.dataTestId;
    var _h = utils.formatAmount({
        value: value,
        currency: currency,
        minority: minority,
        view: view,
        codeFormat: codeFormat,
    }), majorPart = _h.majorPart, minorPart = _h.minorPart, currencySymbol = _h.currencySymbol, currencySeparator = _h.currencySeparator;
    var defaultStyles = bold === undefined && transparentMinor === undefined;
    utils_logWarning.logWarning(currency);
    return (React__default.default.createElement("span", { className: cn__default.default(styles.component, className, (_b = {},
            _b[styles.bold] = bold === 'full' || bold === 'major',
            _b[styles.defaultStyles] = defaultStyles,
            _b)), "data-test-id": dataTestId },
        showPlus && value > 0 ? '+' : '',
        majorPart,
        React__default.default.createElement("span", { className: cn__default.default(styles.minorPartAndCurrency, (_c = {},
                _c[styles.transparentMinor] = transparentMinor,
                _c[styles.normalMinor] = bold === 'major',
                _c[styles.defaultMinor] = defaultStyles,
                _c)) },
            minorPart && utils.AMOUNT_MAJOR_MINOR_PARTS_SEPARATOR,
            trimZero ? utils_trimTrailingZeros.trimTrailingZeros(minorPart) : minorPart,
            currency ? "".concat(currencySeparator).concat(currencySymbol !== null && currencySymbol !== void 0 ? currencySymbol : currency) : null,
            rightAddons)));
};

exports.Amount = Amount;
